// New Voucher component
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./voucher.css";
import { ChangeMode, Configure, OtherVoucher, Period, VoucherTypeNameSelect } from "./voucher_modal/Index";
import { voucherTypeList, filterVoucherTypeData, openModal } from "redux/actions/action-creator";
import { dateFormateShow, dateDayShow, getCurrentFinancialPeriod, currencyFormate } from "components/Date_Formate_Utilitiy/Index";
import Contra from "./Voucher/Contra";
import RecieptPayment from "./Voucher/RecieptPayment";
import HomeLayout from "../../../components/home_page/HomeLayout";
import Sales from "./Voucher/Sales";
import Purchase from "./Voucher/Purchase";
import Indicator from "../../../components/Indicator/Indicator";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { setLastUsedVoucherData } from "utils/localStorage";
import Journal from "./Voucher/Journal";
import { contraVoucherSingle } from "redux/actions/action-creator";
import { LINK_PATH } from "../../../constant";
import { usePermission } from "../../../hooks/usePermission";

const initialState = {
  voucher_type_name: "",
  voucher_type_id: "",
  select_type_of_voucher: "",
  method_of_voucher_number: "",
  serial_no: "",
  voucher_number_series_id: "",
  period_key: "",
  total_amount: "",
  company_id: "",
  create_date: "",
  day_name: "",
  is_checked_series: "1",
  narration: "",
  account: "",
  account_ledger_id: "",
  account_ledger_balance: "",
  data: [
    {
      id: "1",
      first: "",
      particular_ledger_balance: "",
      particular_ledger_id: "",
      particular_ledger_pay_amount: "",
      prev_value: ""
    },
  ],
  is_proceed: "1",
  supplier_ref_no: "",
  party_bill_to: "",
  party_bill_to_ledger_id: "",
  partry_bill_to_current_balance: "",
  data_item: [
    {
      id: "1",
      item_name: "",
      item_id: "",
      godown_location: "",
      godown_location_id: "",
      item_qty: "",
      item_rate: "",
      per_unit: "",
      item_amt: "",
      item_alternate_unit: "",
      is_unit_available: false,
      where_unit_num: "",
      where_alternate_unit_num: "",
      main_unit_name: "",
      combination_of_units: "",
      check_open: false,
      total_nos_box: "",
      total_no_box_unit: "",
    },
  ],

  sale_ledger_data: [
    {
      id: "L1",
      ledger_account: "",
      ledger_account_id: "",
      rate_percentage: "",
      ledger_amount: "",
      check: false,
    },
  ],

  payment_allocation: [
    {
      id: "PA_1",
      ledger_name: "",
      payment_ledger_account_id: "",
      payment_ledger_amount: "",
    },
  ],
  party_bill_to_mailing_name: "",
  bill_to_address: "",
  bill_to_contact: "",

  party_ship_to: "",
  party_ship_to_ledger_id: "",
  party_ship_to_current_balance: "",
  party_ship_to_mailing_name: "",
  ship_to_address: "",
  ship_to_contact: "",

  sale_purchase_ledger_account: "",
  sales_ledger_order_id: "",
  sale_purchase_ledger_current_balance: "",
  dispatch_detail: "Not Available",
  voucher_type: "",
  delivery_note_no: "",
  dispatch_doc_no: "",
  dispatch_through: "",
  destination: "",
  carrier_name_agent: "",
  bill_of_loading: "",
  dispatch_date: "",
  order_detail: "Not Available",
  order_no: "",
  mode_term_payment: "",
  other_reference: "",
  term_of_delivery: "",

  location: "",
  location_id: "",

  bank_ac_od_ledger: "",
  bank_account_od_ledger: "",
  bank_ac_amt: "",
  UTR_CHQ: "",

  cash_in_hand_ledger: "",
  cash_in_hand_ledger_name: "",
  cash_in_hand_amt: "",
  cash_tendered: "",
  balance: "",

  sundry_debitor_ledger: "",
  sundry_debitor_amt: "",
  sundry_debitor_ledger_name: "",
  tran_id: "",

  party_account_ledger: "",
  party_account_name: "",
  party_amount: "",
  party_balance: "",
  total_item_amt: "",

  date_payment: "",

  check_num_series_manual_automatic: "",
  is_unit_available: "",
  where_unit_num: "",
  where_alternate_unit_num: "",
  alternate_unit_name: "",
  main_unit_name: "",
  combination_of_units: "",
  total_amount_item: "",
  total_amount_allocate_party: "",
};

const Vouchers = React.memo(() => {

  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState(() => {
    const saved = sessionStorage.getItem("saved_voucher_form_data");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.path === window.location.pathname) {
          return parsed.data;
        }
      } catch (e) {
        // ignore
      }
    }
    return initialState;
  });
  const [loading, setLoading] = useState(false);

  const isAlter = location.pathname.includes("-alter/");
  const isView = location.pathname.includes("-view/");
  const isDuplicate = !!(id && !isAlter && !isView);

  const { add, alter, view } = usePermission('Voucher Types', data?.select_type_of_voucher || data?.voucher_type_name);

  // Save form data to sessionStorage on change
  useEffect(() => {
    if (!loading && data && data.voucher_type_name) {
      sessionStorage.setItem("saved_voucher_form_data", JSON.stringify({
        path: location.pathname,
        data: data
      }));
    }
  }, [data, loading, location.pathname]);

  // Clear saved form data on unmount (when backing out or quitting)
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("saved_voucher_form_data");
    };
  }, []);

  // get state data from redux
  const { userData } = useSelector((state) => state.auth);
  const { voucher_type_data = null } = useSelector((state) => state.common);
  const { company_session } = useSelector((state) => state.common);
  const modal_state = useSelector((state) => state.common.modal_state);
  const date_formated_show = dateFormateShow(company_session?.current_date);
  const date_day_show = dateDayShow(date_formated_show);

  // check if the data is ready -------------------------
  useEffect(() => {
    const isReady = userData?.company_id && data?.voucher_type_name

    if (isReady) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [userData?.company_id, data?.voucher_type_name]);

  // fetch the voucher type data from the API -------------------------
  const API_Function = useCallback(async () => {
    if (userData?.company_id) {
      try {
        const formdata = new FormData();
        formdata.append('company_id', userData?.company_id);
        dispatch(voucherTypeList(formdata));
      } catch (error) {
        console.log(error);
      }
    }
  }, [userData?.company_id, dispatch]);

  // fetch the voucher type data -------------------------
  useEffect(() => {
    if (userData?.company_id) {
      API_Function();
    }
  }, [userData?.company_id, API_Function]);

  // Fetch single voucher data if ID is present (Alter/View mode)
  useEffect(() => {
    if (id && userData?.company_id) {
      const saved = sessionStorage.getItem("saved_voucher_form_data");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (parsed.path === location.pathname) {
            return;
          }
        } catch (e) { }
      }
      setLoading(true);
      const formdata = new FormData();
      formdata.append("company_id", userData.company_id);
      formdata.append("id", id);
      dispatch(contraVoucherSingle(formdata)).then((response) => {
        if (response?.status && response?.data) {
          const vData = response.data;
          const baseVType = voucher_type_data?.find(v => v.id == vData.voucher_type_id)?.select_type_of_voucher || vData.voucher_type_name;

          const mappedData = {
            ...initialState,
            id: vData.id,
            voucher_type_id: vData.voucher_type_id,
            voucher_type_name: vData.voucher_type_name,
            select_type_of_voucher: baseVType,
            method_of_voucher_number: vData.method_of_voucher_number,
            serial_no: vData.serial_no,
            voucher_number_series_id: vData.voucher_number_series_id,
            period_key: vData.period_key || company_session?.period_key,
            total_amount: vData.total_amount,
            company_id: vData.company_id,
            create_date: dateFormateShow(vData.create_date),
            day_name: dateDayShow(dateFormateShow(vData.create_date)),
            narration: vData.narration,
            account: vData.ledger_name,
            account_ledger_id: vData.account_ledger_id,
            account_ledger_balance: currencyFormate(vData.account_ledger_balance),

            // Map rows (particular_data)
            data: vData.particular_data?.map(p => {
              const dr_cr = p.type || (p.particular_ledger_pay_amount > 0 ? "DR" : "CR");
              return {
                id: p.id,
                first: p.particular_ledger_name,
                particular_ledger_balance: currencyFormate(p.particular_ledger_balance),
                particular_ledger_id: p.particular_ledger_id,
                particular_ledger_pay_amount: currencyFormate(p.particular_ledger_pay_amount),
                debit_amount: dr_cr === "DR" ? currencyFormate(p.particular_ledger_pay_amount) : "",
                credit_amount: dr_cr === "CR" ? currencyFormate(p.particular_ledger_pay_amount) : "",
                prev_value: p.particular_ledger_pay_amount,
                credit_debit: dr_cr
              }
            }) || initialState.data,

            // Map items (data_item)
            data_item: vData.data_item?.map(item => ({
              ...item,
              item_id: item.item_id,
              item_name: item.item_name,
              godown_location: item.godown_location,
              godown_location_id: item.godown_location_id,
              item_qty: item.item_qty, // Keep raw value (e.g. "10 Pcs")
              item_rate: item.item_rate, // Keep raw value
              per_unit: item.per_unit,
              item_amt: currencyFormate(item.item_amt),
              combination_of_units: item.combination_of_units,
              check_open: false
            })) || initialState.data_item,

            // Map additional ledgers (particular_sale_data)
            sale_ledger_data: vData.particular_sale_data?.map(s => ({
              id: s.id,
              ledger_account: s.ledger_name,
              ledger_account_id: s.ledger_id,
              ledger_amount: currencyFormate(s.ledger_amount),
              check: false
            })) || initialState.sale_ledger_data,

            // Map payment allocation rows
            payment_allocation: (() => {
              const rawPA = (vData.payment_allocation && vData.payment_allocation.length > 0)
                ? vData.payment_allocation
                : (vData.particular_payment_data || []);
              return rawPA.map((p, idx) => {
                const ledgerId = p.payment_ledger_account_id || p.payment_ledger_id || p.ledger_id || p.payment_ledger_account;
                const ledgerName = p.ledger_name || p.payment_ledger_name || p.particular_ledger_name || p.ledger_account || p.payment_ledger_account;

                return {
                  id: p.id || `PA_${idx + 1}`,
                  ledger_name: ledgerName,
                  payment_ledger_account: ledgerName, // Consistency with dropdown: this holds the name
                  payment_ledger_account_id: ledgerId,
                  payment_ledger_amount: currencyFormate(p.payment_ledger_amount || p.amount || 0),
                };
              });
            })() || initialState.payment_allocation,

            // Additional fields logic for Sale/Purchase
            party_bill_to: vData.party_bill_to_ledger_name,
            party_bill_to_ledger_id: vData.party_bill_to_ledger_id,
            partry_bill_to_current_balance: vData.party_bill_to_current_balance,
            party_bill_to_mailing_name: vData.party_bill_to_mailing_name,
            bill_to_address: vData.bill_to_address,
            bill_to_contact: vData.bill_to_contact,

            party_ship_to: vData.party_ship_to_ledger_name,
            party_ship_to_ledger_id: vData.party_ship_to_ledger_id,
            party_ship_to_current_balance: vData.party_ship_to_current_balance,
            party_ship_to_mailing_name: vData.party_ship_to_mailing_name,
            ship_to_address: vData.ship_to_address,
            ship_to_contact: vData.ship_to_contact,

            sale_purchase_ledger_account: vData.sales_ledger_order_name,
            sales_ledger_order_id: vData.sales_ledger_order_id,
            sale_purchase_ledger_current_balance: vData.sales_ledger_order_balance,

            supplier_ref_no: vData.supplier_ref_no,
            date_payment: vData.date_payment,
            location: vData.location_name || vData.location,
            location_id: vData.location_id,

            dispatch_detail: vData.dispatch_detail || "Not Available",
            delivery_note_no: vData.delivery_note_no,
            dispatch_doc_no: vData.dispatch_doc_no,
            dispatch_through: vData.dispatch_through,
            destination: vData.destination,
            carrier_name_agent: vData.carrier_name_agent,
            bill_of_loading: vData.bill_of_loading,
            dispatch_date: vData.dispatch_date,

            order_detail: vData.order_detail || "Not Available",
            order_no: vData.order_no,
            mode_term_payment: vData.mode_term_payment,
            other_reference: vData.other_reference,
            term_of_delivery: vData.term_of_delivery,

            party_account_ledger: vData.party_account_ledger,
            party_account_name: vData.party_account_ledger_name,
            party_amount: vData.party_amount,
            party_balance: vData.party_balance,

            // Map totals
            total_item_amt: vData.total_item_amt,
            total_amount: vData.total_amount, // Base total (items)
            total_amount_item: (() => {
              const itemTotal = parseFloat(String(vData.total_amount || 0).replace(/,/g, "")) || 0;
              const expenseTotal = (vData.particular_sale_data || []).reduce((acc, s) => acc + (parseFloat(String(s.ledger_amount || 0).replace(/,/g, "")) || 0), 0);
              return itemTotal + expenseTotal;
            })(),
            total_amount_allocate_party: (() => {
              const itemTotal = parseFloat(String(vData.total_amount || 0).replace(/,/g, "")) || 0;
              const expenseTotal = (vData.particular_sale_data || []).reduce((acc, s) => acc + (parseFloat(String(s.ledger_amount || 0).replace(/,/g, "")) || 0), 0);
              const grandTotal = itemTotal + expenseTotal;

              const total_pa_existing = (vData.payment_allocation || vData.particular_payment_data || [])
                .reduce((acc, p) => acc + (parseFloat(String(p.payment_ledger_amount || 0).replace(/,/g, "")) || 0), 0);

              // If total_amount_allocate_party is provided by API, use it, otherwise use our calculated grand total
              const totalToAllocate = vData.total_amount_allocate_party !== undefined ? parseFloat(String(vData.total_amount_allocate_party).replace(/,/g, "")) : grandTotal;
              return totalToAllocate - total_pa_existing;
            })(),

            // Baseline for balance adjustments
            party_bill_to_baseline_balance: vData.party_bill_to_current_balance,
            party_ship_to_baseline_balance: vData.party_ship_to_current_balance,
            initial_payment_allocation_total: (vData.payment_allocation || vData.particular_payment_data || [])
              .reduce((acc, p) => acc + (parseFloat(String(p.payment_ledger_amount || 0).replace(/,/g, '')) || 0), 0)
          };
          setData(mappedData);
          setLoading(false);
        } else {
          setLoading(false);
        }
      }).catch(err => {
        console.error("Error fetching voucher data:", err);
        setLoading(false);
      });
    }
  }, [id, userData?.company_id, voucher_type_data]);

  const hasInitializedFromState = useRef(false);
  // get the last used voucher data (only if not in Alter/View mode) -------------------------
  useEffect(() => {
    if (!userData?.company_id || id) return; // Skip if ID is present (Alter/View)

    if (location.state?.openModalOnMount) {
      dispatch(openModal(location.state.openModalOnMount));
    }

    const saved = sessionStorage.getItem("saved_voucher_form_data");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.path === location.pathname) {
          return;
        }
      } catch (e) { }
    }
    // Check if we have context passed from DayBook/LedgerVoucher (Add Vch with context)
    if (location.state?.create_date && (location.state?.voucher_type_id || location.state?.voucher_type_name)) {
      if (hasInitializedFromState.current) return;

      try {
        const specificVoucher = voucher_type_data?.find(v =>
          (location.state.voucher_type_id && v.id == location.state.voucher_type_id) ||
          (location.state.voucher_type_name && v.voucher_type_name === location.state.voucher_type_name)
        );

        if (specificVoucher) {
          // Sync available voucher types in Redux state for this category
          const filter_voucher = voucher_type_data?.filter((item) => {
            return (
              item?.select_type_of_voucher?.replace(/\s/g, "")?.toLowerCase() ===
              specificVoucher?.select_type_of_voucher?.replace(/\s/g, "")?.toLowerCase()
            );
          });
          if (filter_voucher?.length > 0) {
            dispatch(filterVoucherTypeData(filter_voucher));
          }

          setData((prev) => ({
            ...prev,
            voucher_type_name: specificVoucher?.voucher_type_name,
            voucher_type_id: specificVoucher?.id,
            method_of_voucher_number: specificVoucher?.method_of_voucher_number,
            select_type_of_voucher: specificVoucher?.select_type_of_voucher,
            company_id: userData?.company_id,
            create_date: location.state.create_date,
            account: specificVoucher?.voucher_type_name, // Pre-fill Account field with voucher name as requested
            day_name: location.state.create_date ? dateDayShow(location.state.create_date) : date_day_show,
            period_key: company_session?.period_key || getCurrentFinancialPeriod(),
          }));
          setLastUsedVoucherData(specificVoucher);
          dispatch(openModal("voucherTypeNameSelect")); // Open selection popup automatically
          hasInitializedFromState.current = true;
          return;
        }
      } catch (err) {
        console.error("Error initializing voucher from state context:", err);
      }
    }

    const stored = localStorage.getItem("voucher_type_default_last");
    let lastVoucher = null;

    if (stored) {
      try {
        lastVoucher = JSON.parse(stored);
      } catch {
        localStorage.removeItem("voucher_type_default_last");
      }
    }
    if (lastVoucher && Object.keys(lastVoucher).length > 0) {
      setData((prev) => ({
        ...prev,
        voucher_type_name: lastVoucher?.voucher_type_name,
        voucher_type_id: lastVoucher?.id,
        method_of_voucher_number: lastVoucher?.method_of_voucher_number,
        select_type_of_voucher: lastVoucher?.select_type_of_voucher,
        company_id: userData?.company_id,
        create_date: date_formated_show,
        day_name: date_day_show,
        period_key: company_session?.period_key || getCurrentFinancialPeriod(),
      }));

    } else if (voucher_type_data && voucher_type_data.length > 0) {
      setData((prev) => ({
        ...prev,
        voucher_type_name: voucher_type_data[0]?.voucher_type_name,
        voucher_type_id: voucher_type_data[0]?.id,
        method_of_voucher_number: voucher_type_data[0]?.method_of_voucher_number,
        select_type_of_voucher: voucher_type_data[0]?.select_type_of_voucher,
        company_id: userData?.company_id,
        create_date: date_formated_show,
        day_name: date_day_show,
        period_key: company_session?.period_key || getCurrentFinancialPeriod(),
      }));

      setLastUsedVoucherData(voucher_type_data[0]);
    }
  }, [userData?.company_id, voucher_type_data, location.state]);

  const [initialDate, setInitialDate] = useState("");
  const isVoucherLoaded = !id || (data && String(data.id) === String(id));

  useEffect(() => {
    if (!loading && isVoucherLoaded && data && data.create_date) {
      if (!initialDate) {
        setInitialDate(data.create_date);
      }
    }
  }, [data?.create_date, loading, initialDate, isVoucherLoaded]);

  const isFormDirty = useCallback(() => {
    if (!data) return false;

    const dateChanged = initialDate && data.create_date && data.create_date !== initialDate;

    const hasEdits =
      dateChanged ||
      (data.narration && data.narration.trim() !== "") ||
      (data.party_bill_to && data.party_bill_to.trim() !== "" && data.party_bill_to !== "Not Applicable" && data.party_bill_to !== "End of List") ||
      (data.party_ship_to && data.party_ship_to.trim() !== "" && data.party_ship_to !== "Not Applicable" && data.party_ship_to !== "End of List") ||
      (data.location && data.location.trim() !== "" && data.location !== "Not Applicable" && data.location !== "End of List") ||
      (data.sale_purchase_ledger_account && data.sale_purchase_ledger_account.trim() !== "" && data.sale_purchase_ledger_account !== "Not Applicable" && data.sale_purchase_ledger_account !== "End of List") ||
      (data.supplier_ref_no && data.supplier_ref_no.trim() !== "") ||
      (data.account && data.account.trim() !== "" && data.account !== data.voucher_type_name) ||
      (data.data_item || []).some(item => item?.item_name && item.item_name.trim() !== "" && item.item_name !== "End of List") ||
      (data.data || []).some(p => p?.first && p.first.trim() !== "" && p.first !== "End of List");

    return !!hasEdits;
  }, [data, initialDate]);

  const displayNameOfVoucherType = useCallback((name, voucher_type_data, specificVoucher = null) => {
    const performSwitch = () => {
      sessionStorage.removeItem("saved_voucher_form_data");
      setInitialDate("");

      if (specificVoucher) {
        if (isAlter || isView) {
          setLastUsedVoucherData(specificVoucher);
          navigate(`${LINK_PATH}/voucherstransaction`);
          return;
        }
        setData((prev) => ({
          ...prev,
          voucher_type_name: specificVoucher?.voucher_type_name,
          voucher_type_id: specificVoucher?.id,
          method_of_voucher_number: specificVoucher?.method_of_voucher_number,
          select_type_of_voucher: specificVoucher?.select_type_of_voucher,
        }));
        setLastUsedVoucherData(specificVoucher);
        return;
      }
      let filter_voucher = [];
      filter_voucher = voucher_type_data?.filter((item) => {
        const itemType = item?.select_type_of_voucher || item?.voucher_type_name;
        return (
          itemType?.replace(/\s/g, "")?.toLowerCase() ===
          name?.replace(/\s/g, "")?.toLowerCase()
        );
      });
      if (filter_voucher?.length > 1) {
        dispatch(filterVoucherTypeData(filter_voucher));
        if (isAlter || isView) {
          navigate(`${LINK_PATH}/voucherstransaction`, {
            state: { openModalOnMount: "voucherTypeNameSelect" }
          });
        } else {
          dispatch(openModal("voucherTypeNameSelect"));
        }
      }
      else if (filter_voucher?.length > 0) {
        if (isAlter || isView) {
          setLastUsedVoucherData(filter_voucher[0]);
          navigate(`${LINK_PATH}/voucherstransaction`);
        } else {
          setData((prev) => ({
            ...prev,
            voucher_type_name: filter_voucher[0]?.voucher_type_name,
            voucher_type_id: filter_voucher[0]?.id,
            method_of_voucher_number: filter_voucher[0]?.method_of_voucher_number,
            select_type_of_voucher: filter_voucher[0]?.select_type_of_voucher,
          }));
          setLastUsedVoucherData(filter_voucher[0]);
        }
      } else {
        console.warn("Voucher type not found:", name);
      }
    };

    performSwitch();
  }, [dispatch, isFormDirty, setData, isAlter, isView, navigate]);

  if (loading) {
    return <Indicator />
  }

  const isCreateMode = !isAlter && !isView && !isDuplicate;
  const hasAccess = (isView && view) || (isAlter && alter) || (isCreateMode && add) || (isDuplicate && add);

  return (
    <HomeLayout
      data={data}
      setData={setData}
      displayNameOfVoucherType={displayNameOfVoucherType}
    >
      {!hasAccess && !loading ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <h3>You do not have permission to access this page.</h3>
        </div>
      ) : (
        <>
          {
            (data?.voucher_type_name?.toLowerCase() === "contra" ||
              data?.select_type_of_voucher?.toLowerCase() === "contra") && (
              <Contra
                key="contra-voucher"
                data={data}
                setData={setData}
                initialState={initialState}
                loading={loading}
                isAlter={isAlter}
                isView={isView}
                isDuplicate={isDuplicate}
              />
            )
          }
          {
            (data?.voucher_type_name?.toLowerCase() === "receipt" ||
              data?.select_type_of_voucher?.toLowerCase() === "receipt" ||
              data?.voucher_type_name?.toLowerCase() === "payment" ||
              data?.select_type_of_voucher?.toLowerCase() === "payment") && (
              <RecieptPayment
                key="reciept-payment-voucher"
                data={data}
                setData={setData}
                initialState={initialState}
                loading={loading}
                isAlter={isAlter}
                isView={isView}
                isDuplicate={isDuplicate}
              />
            )
          }
          {
            (data?.voucher_type_name?.toLowerCase() === "sales" ||
              data?.select_type_of_voucher?.toLowerCase() === "sales" ||
              data?.voucher_type_name?.toLowerCase() === "credit note" ||
              data?.select_type_of_voucher?.toLowerCase() === "credit note") && (
              <Sales
                key="sales-voucher"
                data={data}
                setData={setData}
                initialState={initialState}
                loading={loading}
                isAlter={isAlter}
                isView={isView}
                isDuplicate={isDuplicate}
              />
            )
          }
          {
            (data?.voucher_type_name?.toLowerCase() === "purchase" ||
              data?.select_type_of_voucher?.toLowerCase() === "purchase" ||
              data?.voucher_type_name?.toLowerCase() === "debit note" ||
              data?.select_type_of_voucher?.toLowerCase() === "debit note") && (
              <Purchase
                key="purchase-voucher"
                data={data}
                setData={setData}
                initialState={initialState}
                loading={loading}
                isAlter={isAlter}
                isView={isView}
                isDuplicate={isDuplicate}
              />
            )
          }
          {
            (data?.voucher_type_name?.toLowerCase() === "journal" ||
              data?.select_type_of_voucher?.toLowerCase() === "journal") && (
              <Journal
                key="journal-voucher"
                data={data}
                setData={setData}
                initialState={initialState}
                loading={loading}
                isAlter={isAlter}
                isView={isView}
                isDuplicate={isDuplicate}
              />
            )
          }
        </>
      )}

      {modal_state?.period &&
        (<Period
          setData={setData}
          data={data}
        />)}

      {modal_state?.changeMode &&
        (<ChangeMode
          setData={setData}
          data={data}
        />
        )}
      {modal_state?.configure &&
        (<Configure
          setData={setData}
          data={data}
        />
        )}

      {modal_state?.voucherTypeNameSelect &&
        (<VoucherTypeNameSelect
          loading_voucher={false}
          setLoading_voucher={() => { }}
          setData={setData}
          data={data}
        />
        )}

      {modal_state?.otherVoucher &&
        (<OtherVoucher
          setData={setData}
          data={data}
          displayNameOfVoucherType={displayNameOfVoucherType}
        />
        )}
    </HomeLayout>
  );
});

export default Vouchers;
